import React, { useContext } from 'react';
import { BannerContext } from '../../contexts/BannerContext';
import Notification from './Notification';
import useIsMobile from '../../hooks/useIsMobile';

/**
 * Renders the BannerContext toast stack (bottom-right).
 * Newest notifications sit above older ones so sticky toasts aren't replaced.
 */
export default function NotificationStack() {
  const { notifications = [], dismissNotification } = useContext(BannerContext);
  const isMobile = useIsMobile(768, 1024);

  if (!notifications.length) return null;

  const bottomOffset = isMobile ? '80px' : '20px';

  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: bottomOffset,
        right: 20,
        left: isMobile ? 12 : 'auto',
        zIndex: 9999999,
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 8,
        alignItems: isMobile ? 'stretch' : 'flex-end',
        maxWidth: isMobile ? 'calc(100vw - 24px)' : 400,
        width: isMobile ? 'auto' : 400,
        pointerEvents: 'none',
      }}
    >
      {notifications.map((n) => (
        <div key={n.id} style={{ pointerEvents: 'auto', width: '100%' }}>
          <Notification
            message={n.text}
            type={n.type}
            onClose={() => dismissNotification(n.id)}
            onClick={n.onClick || undefined}
            position="inline"
          />
        </div>
      ))}
    </div>
  );
}
